/*
 * ce-size-system.js — "Size system" switch (US / UK / EU / JP) for products whose size values are multi-system lines.
 * Every size label carries all systems (snippets/ce-size-label.liquid); CSS shows the one named by
 * <html data-ce-size-system> (or the server default). Switching = set that attribute + remember it in localStorage
 * (layout/theme.liquid restores it before first paint). No fetch, no re-apply: server re-renders (variant change, cart
 * drawer, cart page, cached section renders) cannot revert the choice. The switch lives inside Dawn's <variant-selects>,
 * so its change event is stopped in the capture phase (Dawn must never treat it as an option) and the select is
 * re-synced after every re-render. Also rewrites the "RING SIZE:" legend right after Dawn writes the raw option value.
 */
(() => {
  const SYSTEMS = ['us', 'uk', 'eu', 'jp'];
  const KEY = 'ce_size_system';
  const SWITCH = '[data-ce-size-switch]';
  const root = document.documentElement;
  const current = () => root.getAttribute('data-ce-size-system');
  const syncSwitches = (scope = document) => {
    const sys = current();
    if (!sys) return;
    scope.querySelectorAll(SWITCH).forEach((select) => { if (select.value !== sys) select.value = sys; });
  };
  const set = (sys) => {
    root.setAttribute('data-ce-size-system', sys);
    try { localStorage.setItem(KEY, sys); } catch (error) { /* private mode */ }
    syncSwitches();
  };
  syncSwitches();

  // the switch: handled first (capture) and hidden from Dawn's variant-selects
  document.addEventListener('change', (event) => {
    const select = event.target.closest(SWITCH);
    if (!select) return;
    event.stopPropagation();
    if (SYSTEMS.includes(select.value)) set(select.value);
  }, true);

  // size buttons: Dawn's variant-selects (ran just before, lower in the tree) writes the RAW option value — the full
  // multi-system line — into the legend. Put the multi-system label back before the browser paints.
  document.addEventListener('change', (event) => {
    const input = event.target.closest('fieldset input[type="radio"]');
    if (!input) return;
    const label = document.querySelector(`label[for="${input.id}"] .ce-size-label`);
    const legend = input.closest('fieldset').querySelector('[data-selected-value]');
    if (label && legend) legend.innerHTML = label.outerHTML;
  });

  // Dawn re-renders <variant-selects> on every variant change: the fresh switch shows the server default → re-sync
  const info = document.querySelector('product-info') || document.body;
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1 && (node.matches(SWITCH) || node.querySelector(SWITCH))) { syncSwitches(node.parentNode || node); return; }
      }
    }
  }).observe(info, { childList: true, subtree: true });
})();
